import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [stats, setStats] = useState({
    students: 0,
    courses: 0,
    questions: 0,
    successRate: 0
  });

  const targetStats = {
    students: 15000,
    courses: 500,
    questions: 50000,
    successRate: 98
  };

  useEffect(() => {
    const duration = 2000;
    const steps = 100;
    const interval = duration / steps;

    const timer = setInterval(() => {
      setStats(prev => ({
        students: Math.min(prev.students + targetStats.students / steps, targetStats.students),
        courses: Math.min(prev.courses + targetStats.courses / steps, targetStats.courses),
        questions: Math.min(prev.questions + targetStats.questions / steps, targetStats.questions),
        successRate: Math.min(prev.successRate + targetStats.successRate / steps, targetStats.successRate)
      }));
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="min-h-screen flex items-center relative pt-16" id="home">
      <div className="max-w-[1400px] mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Content */}
        <div className="z-10">
          {/* Logo */}
          {/* <div className="mb-8">
            <img 
              src="/logo.png" 
              alt="BESST Logo" 
              className="h-24 md:h-32 w-auto object-contain"
            />
          </div> */}

           
           <Link to="/courses" className="hero-badge mt-10">
              Explore our courses
            </Link>
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight mb-8 gradient-text">
            Future of Learning Starts Here
          </h1>
          
          <p className="text-xl text-text-muted leading-relaxed mb-12">
            Experience next-generation education with AI-powered learning, 
            immersive virtual classrooms, and personalized study paths that 
            adapt to your unique learning style.
          </p>
          
          <div className="flex flex-wrap gap-6">
            <Link to="/cuet-ug" className="btn-primary">
              CUET (UG)
            </Link>
            <Link to="/cuet-pg" className="btn-secondary">
              CUET (PG)
            </Link>
            <Link to="/net-jrf" className="btn-primary">
              NET / JRF
            </Link>
          </div>
        </div>

        {/* Stats Card */}
        <div className="flex justify-center items-center">
          <div className="glass-card w-full max-w-[500px] relative gradient-border"
            style={{ 
              transform: 'perspective(1000px) rotateY(-5deg) rotateX(5deg)',
              transition: 'transform 0.5s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) rotateX(0deg)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'perspective(1000px) rotateY(-5deg) rotateX(5deg)'}
          >
            <div className="grid grid-cols-2 gap-8">
              <div className="stat-item text-center">
                <div className="stat-number">{Math.floor(stats.students).toLocaleString()}</div>
                <div className="stat-label">Students</div>
              </div>
              <div className="stat-item text-center">
                <div className="stat-number">{Math.floor(stats.courses)}</div>
                <div className="stat-label">Courses</div>
              </div>
              <div className="stat-item text-center">
                <div className="stat-number">{Math.floor(stats.questions).toLocaleString()}</div>
                <div className="stat-label">Questions</div>
              </div>
              <div className="stat-item text-center">
                <div className="stat-number">{Math.floor(stats.successRate)}%</div>
                <div className="stat-label">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
